import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138259ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col flex-1 mt-[189px]" }
const _hoisted_2 = { class: "flex max-w-[1126px] mx-auto w-full mb-[76px]" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 z-30 bg-black/50"
}
const _hoisted_4 = { class: "flex items-center border-[3px] border-[var(--primary-color)] rounded-[100px] px-[24.5px] py-[10px] w-fit ml-auto" }
const _hoisted_5 = { class: "reservation" }
const _hoisted_6 = { class: "flex items-center gap-x-[88px]" }
const _hoisted_7 = {
  key: 0,
  class: "show fixed inset-0 z-30 l:top-[30%] l:left-[50%] l:translate-x-[-50%] l:translate-y-[-30%]"
}
const _hoisted_8 = { class: "flex max-w-[1126px] mx-auto p-3 w-full mb-[60px]" }
const _hoisted_9 = { class: "flex flex-col border-[3px] border-[var(--primary-color)] rounded-[50px] py-6 min-w-[600px]" }
const _hoisted_10 = { class: "flex items-center gap-x-3 mb-3 px-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_12 = { class: "flex flex-col px-10 max-w-[450px] l:max-w-[500px] xl:max-w-[550px]" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex flex-col max-w-[1126px] mx-auto w-full" }
const _hoisted_16 = { class: "mb-[56px]" }
const _hoisted_17 = { class: "p-3 mb-10" }
const _hoisted_18 = { class: "pl-5 mt-4" }
const _hoisted_19 = { class: "list-disc pl-10 mt-4" }
const _hoisted_20 = { class: "pl-5 mt-4" }
const _hoisted_21 = { class: "pl-5 mt-4" }

import { ref } from 'vue';
import { useGlobalStore } from '@/stores/global';
import { useRouter } from 'vue-router';
import ReturnButton from '@/components/common/ReturnButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseAccordion from '@/components/common/BaseAccordion.vue';
import TourForm from './TourForm.vue';
import MarkdownIt from 'markdown-it';


export default /*#__PURE__*/_defineComponent({
  __name: 'TourDesktop',
  setup(__props) {

const strapiUrl = process.env.VUE_APP_STRAPI_URL;

const md = new MarkdownIt();
const router = useRouter();
const id = +router.currentRoute.value.params.id;

const toggle = ref<boolean>(false);
const tour = ref<any>();

const toggleForm = () => (toggle.value = !toggle.value);

const globalStore = useGlobalStore();
const { getTour } = globalStore;

const onLoad = async () => {
    tour.value = await getTour(id);
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (toggle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(ReturnButton, {
        text: tour.value?.data.attributes?.title
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseTypography, {
          text: tour.value?.data.attributes?.days,
          type: "subtitle2",
          class: "whitespace-nowrap"
        }, null, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: tour.value?.data?.attributes.summForGroup,
            type: "subtitle",
            color: "var(--secondary-color)",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: " ₽/чел",
            type: "body2",
            tag: "span"
          }),
          _createVNode(BaseTypography, {
            text: tour.value?.data?.attributes.group,
            type: "body"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: tour.value?.data?.attributes.summForInd,
            type: "subtitle",
            color: "var(--secondary-color)",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: " ₽/чел",
            type: "body2",
            tag: "span"
          }),
          _createVNode(BaseTypography, {
            text: tour.value?.data?.attributes.tourType,
            type: "body"
          }, null, 8, ["text"])
        ])
      ]),
      _createVNode(BaseButton, {
        text: "Забронировать",
        "padding-y": "20",
        "padding-x": "64",
        type: "subtitle4",
        color: "var(--base-white)",
        ui: "primary-with-back",
        onClick: toggleForm
      })
    ]),
    (toggle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(TourForm, { onClose: toggleForm })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(BaseTypography, {
        text: "Программа",
        type: "subtitle"
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tour.value?.data.attributes.tourDescription, (desc) => {
      return (_openBlock(), _createElementBlock("div", {
        key: desc.id,
        class: "flex gap-x-10 max-w-[1126px] mx-auto w-full mb-12"
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(BaseTypography, {
              text: desc.title,
              type: "special-body",
              color: "var(--primary-color)"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              innerHTML: _unref(md).render(desc.dayDescription)
            }, null, 8, _hoisted_13)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desc.dayImgs?.data, (img) => {
          return (_openBlock(), _createElementBlock("div", {
            key: img.id,
            class: "flex items-center gap-x-10"
          }, [
            _createElementVNode("img", {
              src: _unref(strapiUrl) + img.attributes.url,
              class: "h-[216px] w-[216px] rounded-full object-cover"
            }, null, 8, _hoisted_14)
          ]))
        }), 128))
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(BaseTypography, {
            text: "Часто задаваемые вопросы",
            type: "subtitle"
          })
        ]),
        _createVNode(BaseAccordion, {
          title: "Как забронировать и оплатить",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(BaseTypography, {
                text: "Шаг 1: отправить заявку",
                type: "body2",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "Забронировать тур вы можете следующим образом:",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "- нажать кнопку «ЗАБРОНИРОВАТЬ» в описании экскурсии;",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "- написать на почтовый адрес reserv@rvm-spb.ru;",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "- отправить запрос по электронной почте info@rvm-spb.ru.",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "Шаг 2: оплатить билеты",
                type: "body2",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "У вас есть 2 способа сделать это:",
                type: "body",
                class: "mb-6"
              }),
              _createVNode(BaseTypography, {
                text: "1) Удалённо, через различные системы оплат (расчет с использованием реквизитов банковской карты, переводом через интернет-банк).",
                type: "body"
              }),
              _createVNode(BaseTypography, {
                text: "2) Подъехать заранее к нам в офис и оплатить наличными или по картам VISA, Mastercard, МИР. Наш офис в Бизнес центре 'Петровский форт', Финляндский проспект 4А, офис 201",
                type: "body",
                class: "mb-6"
              }),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: "Внимание! ",
                  type: "body2",
                  tag: "span"
                }),
                _createVNode(BaseTypography, {
                  text: "Заявка на тур подтверждается только специалистом компании.",
                  type: "body",
                  tag: "span"
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Способ оплаты",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Visa",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "MasterCard",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Сбербанк",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "ВТБ",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Тинькофф",
                  type: "body"
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: "Наличными",
                  type: "body"
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Сроки оплаты тура",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(BaseTypography, {
                text: "Сроки оплаты тура указываются в договоре, который заключается после подтверждении бронирования тура.",
                type: "body"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseAccordion, {
          title: "Условия отмены бронирования",
          class: "mb-[30px]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(BaseTypography, {
                text: "Условия отмены бронирования указываются в договоре, который заключается после подтверждении бронирования тура.",
                type: "body"
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})